import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-tables-bootstrap-8',
  templateUrl: './8.component.html',
  styleUrls: ['./8.component.scss'],
})
export class VbTablesBootstrap8Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
